export const dummySidebar = {
  vi: [
    {
      name: "Tổng quan",
      path: "/dashboard",
      componentName: "GeneralFeature",
      icon: "https://apiv2.mobitopup.vn/file/4298df92-a6db-4f32-8808-469406142908.png",
      enable: true,
      subMenu: [],
    },
    {
      name: "Lịch sử GD",
      path: "/transaction-history",
      componentName: "transaction-history",
      icon: "https://apiv2.mobitopup.vn/file/e218a50a-d38c-46c1-b65e-7e1b2d089917.png",
      enable: true,
      subMenu: [
        {
          name: "Nạp tiền điện thoại",
          path: "/transaction-history/app-air-time-charge",
          componentName: "AirTimeRegistrationFeature",
          icon: "https://apiv2.mobitopup.vn/file/508dc94b-d8ae-4d4a-8f4f-6517dc50bfe5.png",
          enable: true,
          subMenu: [],
        },
        {
          name: "Gói cước",
          path: "/transaction-history/app-data-charge",
          componentName: "AppDataRegisterFeature",
          icon: "https://apiv2.mobitopup.vn/file/855a69e1-00a6-475f-bcb9-b43af89c0ac3.png",
          enable: true,
          subMenu: [],
        },
        {
          name: "SIM",
          path: "/transaction-history/app-sim-mobifone",
          componentName: "AppSimMobifoneFeature",
          icon: "https://apiv2.mobitopup.vn/file/845231d3-4964-4cb3-8850-a1d04a79008f.png",
          enable: true,
          subMenu: [],
        },
        {
          name: "SIM số đẹp",
          path: "/transaction-history/app-nice-sim",
          componentName: "AppNiceSimFeature",
          icon: "https://apiv2.mobitopup.vn/file/ba67101f-be99-4baf-8489-d4abf2d18a44.png",
          enable: true,
          subMenu: [],
        },
        {
          name: "SIM Hello Vietnam",
          path: "/transaction-history/inbound-sim",
          componentName: "InboundTravelSimFeature",
          icon: "https://apiv2.mobitopup.vn/file/3f6772ce-3e38-4b2f-85e9-a505c7140368.png",
          enabled: true,
          subMenu: [],
        },
        // {
        //   name: "SIM Let go",
        //   path: "/transaction-history/outbound-sim",
        //   componentName: "OutboundTravelSimFeature",
        //   icon: "https://apiv2.mobitopup.vn/file/3f6772ce-3e38-4b2f-85e9-a505c7140368.png",
        //   enabled: true,
        //   subMenu: [],
        // },
        {
          name: "Dòng tiền",
          path: "/transaction-history/cash-flow",
          componentName: "CashFlowFeature",
          icon: "https://apiv2.mobitopup.vn/file/2f20c9c9-1dff-4ac1-a4b8-9f85ed003a26.png",
          enabled: true,
          subMenu: [],
        },
      ],
    },
    {
      name: "Hỗ trợ",
      path: "/systems",
      componentName: "systems",
      icon: "https://apiv2.mobitopup.vn/file/79578057-8537-4053-a7ae-5749941a8472.png",
      enable: true,
      subMenu: [
        // {
        //   name: "Tra cứu SIM",
        //   path: "/systems/review-sim",
        //   componentName: "SimLookupFeature",
        //   icon: "https://apiv2.mobitopup.vn/file/4c62d35d-f644-40ac-ac1c-8e23a282368f.png",
        //   enable: true,
        //   subMenu: [],
        // },
        // {
        //   name: "Tra cứu gói cước",
        //   path: "/systems/review-package",
        //   componentName: "PackageLookupFeature",
        //   icon: "https://apiv2.mobitopup.vn/file/d3777234-2b1c-4633-88a8-91a98019839b.png",
        //   enable: true,
        //   subMenu: [],
        // },
        // {
        //   name: "Tài liệu hỗ trợ API",
        //   path: "/systems/api-docs",
        //   componentName: "ApiDocManagementFeature",
        //   icon: "https://apiv2.mobitopup.vn/file/a937bf65-964a-44d9-9783-da7a015bb03e.png",
        //   enable: true,
        //   subMenu: [],
        // },
        {
          name: "Văn bản",
          path: "/systems/official-dispatch",
          componentName: "DispatchManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/676dffee-8e4c-45d3-8945-6c38e407e837.png",
          enable: true,
          subMenu: [],
        },
      ],
    },
    {
      name: "Quản lý tài khoản",
      path: "/account",
      componentName: "account-management",
      icon: "https://apiv2.mobitopup.vn/file/e24ed9aa-48e6-4404-aa66-b9d21d5f166f.png",
      enable: true,
      subMenu: [
        {
          name: "Cửa hàng",
          path: "/account/store",
          componentName: "StoreManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/92edebab-706f-4770-a130-aef8da8a66fd.png",
          enable: true,
          subMenu: [],
        },
        {
          name: "Nhân viên",
          path: "/account/staff",
          componentName: "StaffManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/aca2d358-38e3-47a6-a505-b2f50cbbdea6.png",
          enable: true,
          subMenu: [],
        },
      ],
    },
  ],
  eng: [
    {
      name: "Dashboard",
      path: "/dashboard",
      componentName: "GeneralFeature",
      icon: "https://apiv2.mobitopup.vn/file/4298df92-a6db-4f32-8808-469406142908.png",
      enabled: true,
      subMenu: [],
    },
    {
      name: "Transaction history",
      path: "/transaction-history",
      componentName: "transaction-history",
      icon: "https://apiv2.mobitopup.vn/file/e218a50a-d38c-46c1-b65e-7e1b2d089917.png",
      enabled: true,
      subMenu: [
        {
          name: "Phone credit",
          path: "/transaction-history/app-air-time-charge",
          componentName: "AirTimeRegistrationFeature",
          icon: "https://apiv2.mobitopup.vn/file/508dc94b-d8ae-4d4a-8f4f-6517dc50bfe5.png",
          enable: true,
          subMenu: [],
        },
        {
          name: "Data Package",
          path: "/transaction-history/app-data-charge",
          componentName: "AppDataRegisterFeature",
          icon: "https://apiv2.mobitopup.vn/file/855a69e1-00a6-475f-bcb9-b43af89c0ac3.png",
          enabled: true,
          subMenu: [],
        },
        {
          name: "SIM",
          path: "/transaction-history/app-sim-mobifone",
          componentName: "AppSimMobifoneFeature",
          icon: "https://apiv2.mobitopup.vn/file/845231d3-4964-4cb3-8850-a1d04a79008f.png",
          enabled: true,
          subMenu: [],
        },
        {
          name: "Nice SIM",
          path: "/transaction-history/app-nice-sim",
          componentName: "AppNiceSimFeature",
          icon: "https://apiv2.mobitopup.vn/file/ba67101f-be99-4baf-8489-d4abf2d18a44.png",
          enabled: true,
          subMenu: [],
        },
        {
          name: "Hello Vietnam SIM",
          path: "/transaction-history/inbound-sim",
          componentName: "InboundTravelSimFeature",
          icon: "https://apiv2.mobitopup.vn/file/3f6772ce-3e38-4b2f-85e9-a505c7140368.png",
          enabled: true,
          subMenu: [],
        },
        // {
        //   name: "Let go SIM",
        //   path: "/transaction-history/outbound-sim",
        //   componentName: "OutboundTravelSimFeature",
        //   icon: "https://apiv2.mobitopup.vn/file/3f6772ce-3e38-4b2f-85e9-a505c7140368.png",
        //   enabled: true,
        //   subMenu: [],
        // },
        {
          name: "Cash Flow",
          path: "/transaction-history/cash-flow",
          componentName: "CashFlowFeature",
          icon: "https://apiv2.mobitopup.vn/file/2f20c9c9-1dff-4ac1-a4b8-9f85ed003a26.png",
          enabled: true,
          subMenu: [],
        },
      ],
    },
    {
      name: "Support",
      path: "/systems",
      componentName: "systems",
      icon: "https://apiv2.mobitopup.vn/file/79578057-8537-4053-a7ae-5749941a8472.png",
      enabled: true,
      subMenu: [
        // {
        //   name: "SIM Status",
        //   path: "/systems/review-sim",
        //   componentName: "SimLookupFeature",
        //   icon: "https://apiv2.mobitopup.vn/file/4c62d35d-f644-40ac-ac1c-8e23a282368f.png",
        //   enabled: true,
        //   subMenu: [],
        // },
        // {
        //   name: "Data package info and usage",
        //   path: "/systems/review-package",
        //   componentName: "PackageLookupFeature",
        //   icon: "https://apiv2.mobitopup.vn/file/d3777234-2b1c-4633-88a8-91a98019839b.png",
        //   enabled: true,
        //   subMenu: [],
        // },
        // {
        //   name: "API Documentation",
        //   path: "/systems/api-docs",
        //   componentName: "ApiDocManagementFeature",
        //   icon: "https://apiv2.mobitopup.vn/file/a937bf65-964a-44d9-9783-da7a015bb03e.png",
        //   enabled: true,
        //   subMenu: [],
        // },
        {
          name: "Official Dispatch",
          path: "/systems/official-dispatch",
          componentName: "DispatchManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/676dffee-8e4c-45d3-8945-6c38e407e837.png",
          enabled: true,
          subMenu: [],
        },
      ],
    },
    {
      name: "Account management",
      path: "/account",
      componentName: "account-management",
      icon: "https://apiv2.mobitopup.vn/file/e24ed9aa-48e6-4404-aa66-b9d21d5f166f.png",
      enabled: true,
      subMenu: [
        {
          name: "Store",
          path: "/account/store",
          componentName: "StoreManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/92edebab-706f-4770-a130-aef8da8a66fd.png",
          enabled: true,
          subMenu: [],
        },
        {
          name: "Staff",
          path: "/account/staff",
          componentName: "StaffManagementFeature",
          icon: "https://apiv2.mobitopup.vn/file/aca2d358-38e3-47a6-a505-b2f50cbbdea6.png",
          enabled: true,
          subMenu: [],
        },
      ],
    },
  ],
};
